import NotificationTypes from "./notifications.types";

const INITIAL_STATE = {
  notifications: [],
  unreadCount: 0,
  connectionStatus: "disconnected", // 'disconnected' | 'connecting' | 'connected' | 'error'
  isLoading: false,
  error: null,
};

const notificationsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NotificationTypes.ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [action.payload, ...state.notifications],
        unreadCount: state.unreadCount + 1,
      };

    case NotificationTypes.SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
        unreadCount: action.payload.filter((n) => !n.read).length,
      };

    case NotificationTypes.MARK_AS_READ:
      return {
        ...state,
        notifications: state.notifications.map((notification) =>
          action.payload.includes(notification._id || notification.id)
            ? { ...notification, read: true, readAt: new Date().toISOString() }
            : notification,
        ),
        unreadCount: Math.max(0, state.unreadCount - action.payload.length),
      };

    case NotificationTypes.MARK_ALL_AS_READ:
      return {
        ...state,
        notifications: state.notifications.map((notification) => ({
          ...notification,
          read: true,
          readAt: new Date().toISOString(),
        })),
        unreadCount: 0,
      };

    case NotificationTypes.CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
        unreadCount: 0,
      };

    case NotificationTypes.SET_CONNECTION_STATUS:
      return {
        ...state,
        connectionStatus: action.payload,
      };

    case NotificationTypes.SET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: action.payload,
      };

    case NotificationTypes.REMOVE_NOTIFICATION:
      const removedNotification = state.notifications.find(
        (n) => (n._id || n.id) === action.payload,
      );
      return {
        ...state,
        notifications: state.notifications.filter(
          (n) => (n._id || n.id) !== action.payload,
        ),
        unreadCount:
          removedNotification && !removedNotification.read
            ? state.unreadCount - 1
            : state.unreadCount,
      };

    case NotificationTypes.FETCH_NOTIFICATIONS_START:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case NotificationTypes.FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.payload,
        unreadCount: action.payload.filter((n) => !n.read).length,
        isLoading: false,
      };

    case NotificationTypes.FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default notificationsReducer;
